
const AnniversaryDayData23 = [
    {
        id: 1,
        imageSource: require("../../../Assets/Events/2023/Anniversary_Day_2023/Anniversary_Day_2023_1.webp")
    },
    {
        id: 2,
        imageSource: require("../../../Assets/Events/2023/Anniversary_Day_2023/Anniversary_Day_2023_2.webp")
    },
    {
        id: 3,
        imageSource: require("../../../Assets/Events/2023/Anniversary_Day_2023/Anniversary_Day_2023_3.webp")
    },
    {
        id: 4,
        imageSource: require("../../../Assets/Events/2023/Anniversary_Day_2023/Anniversary_Day_2023_4.webp")
    },
    {
        id: 5,
        imageSource: require("../../../Assets/Events/2023/Anniversary_Day_2023/Anniversary_Day_2023_5.webp")
    },
    {
        id: 6,
        imageSource: require("../../../Assets/Events/2023/Anniversary_Day_2023/Anniversary_Day_2023_6.webp")
    }
];

export default AnniversaryDayData23;